import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ScrollProvider } from './Utils/ScrollContext';
import './App.css';
import ScrollToTop from './components/ScrollToTop';
import HomePage from 'pages/HomePage';

// Lazy load components
const Layout = lazy(() => import('./components/Layout/Layout'));
// const SolutionPage = lazy(() => import('./pages/Solutions/SolutionPage'));
const CareersPage = lazy(() => import('./pages/Careers/CareersPage'));
const PeregrineDrone = lazy(() => import('./pages/OurDrones/PeregrineDrone'));
const F400Drone = lazy(() => import('./pages/OurDrones/F400Drone'));
const Axl30Drone = lazy(() => import('./pages/OurDrones/Axl30'));
const AxlOneView = lazy(() => import('./pages/OurDrones/pages/AxlOneView/AxlOneView'));
const AxlOrbit = lazy(() => import('./pages/OurDrones/pages/AxlOrbit/AxlOrbit'));
const PDB = lazy(() => import('./pages/OurDrones/pages/pdb/PDB'));
const RentADronePage = lazy(() => import('./pages/RentADone/RentADonePage'));
const AakashSoftware = lazy(() => import('./pages/Software/Akash/AakashSoftware'));
const VimanApp = lazy(() => import('./pages/Software/Akash/VimanApp'));
const Resellers = lazy(() => import('./pages/OurPartners/Resellers/Resellers'));
const Blog = lazy(() => import('./pages/Cases/Blog'));
const Blog1 = lazy(() => import('./pages/Blog/BlogDetail'));
const Leadership = lazy(() => import('./pages/Whoweare/Leadership'));
const AboutSection = lazy(() => import('./pages/AboutSection/AboutSection'));
const NewsSection = lazy(() => import('./pages/News/NewsSection'));
const Media = lazy(() => import('./pages/Media/Media'));
const ProductRegistration = lazy(() => import('./pages/ProductRegistration/ProductRegistration'));
const GetInTouch = lazy(() => import('./pages/GetInTouch/GetInTouch'));
const ContactUspage = lazy(() => import('./pages/ContactUs/ContactUspage'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy/PrivacyPolicy'));
const TermsOfUse = lazy(() => import('./pages/TermsOfUse/TermsOfUse'));
const PageNotFound = lazy(() => import('./pages/PageNotFound'));
// const DroneParticles = lazy(() => import('./pages/DroneParticles'));

function App() {
  return (
    <Router>
      <ScrollToTop />
      <ScrollProvider>
        <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '20%' }}>Loading...</div>}>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />
              {/* <Route path="our-drones" element={<SolutionPage />} /> */}
              <Route path="careers" element={<CareersPage />} />
              <Route path="peregrine" element={<PeregrineDrone />} />
              <Route path="F400" element={<F400Drone />} />
              <Route path="axl30" element={<Axl30Drone />} />
              <Route path="AakashSoftware" element={<AakashSoftware />} />
              <Route path="VimanApp" element={<VimanApp />} />
              <Route path="RentADrone" element={<RentADronePage />} />
              <Route path="contact-us" element={<ContactUspage />} />
              <Route path="privacypolicy" element={<PrivacyPolicy />} />
              <Route path="Resellers" element={<Resellers />} />
              <Route path="Blog" element={<Blog />} />
              <Route path="Leadership" element={<Leadership />} />
              <Route path="getintouch" element={<GetInTouch />} />
              <Route path="axlOneView" element={<AxlOneView />} />
              <Route path="GPS" element={<AxlOrbit />} />
              <Route path="PDB" element={<PDB />} />
              <Route path="AboutUs" element={<AboutSection />} />
              <Route path="News" element={<NewsSection />} />
              <Route path="Media" element={<Media />} />
              <Route path="ProductRegistration" element={<ProductRegistration />} />
              <Route path="TermsOfUse" element={<TermsOfUse />} />
              {/* <Route path="droneparticles" element={<DroneParticles />} /> */}
              <Route path="blog/:slug" element={<Blog1 />} />
              <Route path="*" element={<PageNotFound />} />
            </Route>
          </Routes>
        </Suspense>
      </ScrollProvider>
    </Router>
  );
}

export default App;